import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {HeaderNavbarContainerWsopBox} from "./header-navbar-container.wsop.box";
import {HeaderNavbarContainerDefaultBox} from "./header-navbar-container.default.box";
import {HeaderNavbarContainerHarrahsBox} from "./header-navbar-container.harrahs.box";
import {HeaderNavbarContainerCasino777Box} from "./header-navbar-container.casino777.box";

export const HeaderNavbarContainerBox = styledByTheme(HeaderNavbarContainerDefaultBox).forWsop(HeaderNavbarContainerWsopBox).forHarrahs(HeaderNavbarContainerHarrahsBox).forCasino777(HeaderNavbarContainerCasino777Box).apply();
